import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { meetingsAPI } from '../../lib/api';
import MeetingStatusBadge from '../meetings/MeetingStatusBadge';
import { fmtDateTimeInTz } from '../meetings/meetingsUtils';

export default function CompanyMeetingsTab({ companyType, companyRef }) {
  const [timeline, setTimeline] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    meetingsAPI.companyTimeline(companyType, companyRef)
      .then((r) => setTimeline(r.data))
      .catch(() => setTimeline(null))
      .finally(() => setLoading(false));
  }, [companyType, companyRef]);

  if (loading) return <div className="flex justify-center py-8" data-testid="company-meetings-loading"><Loader2 className="animate-spin h-5 w-5" /></div>;
  if (!timeline || (timeline.meetings || []).length === 0) {
    return <p className="text-sm text-muted-foreground text-center py-6" data-testid="no-company-meetings-msg">No visits or meetings recorded yet.</p>;
  }

  return (
    <div className="space-y-2" data-testid="company-meetings-tab">
      <p className="text-xs text-muted-foreground">{timeline.open_actions} open action item(s) from past meetings.</p>
      {timeline.meetings.map((m) => (
        <div key={m.id} className="flex items-center gap-2 border rounded-sm px-3 py-2 text-sm cursor-pointer hover:bg-muted/30"
          onClick={() => navigate(`/meetings/${m.id}`)} data-testid={`company-meeting-row-${m.id}`}>
          <div className="flex-1 min-w-0">
            <p className="truncate">{fmtDateTimeInTz(m.start_at, 'UTC')} · {m.organiser_name} · {m.mode === 'PHYSICAL' ? 'In person' : 'Virtual'}</p>
            {m.summary && <p className="text-xs text-muted-foreground truncate">{m.summary}</p>}
          </div>
          {m.relationship_rating && <span className="text-xs text-muted-foreground">★ {m.relationship_rating}</span>}
          <MeetingStatusBadge status={m.status} />
        </div>
      ))}
    </div>
  );
}
